import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Model_Compare_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_MODELCOMPARE_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: 'WB Model Compare Id',
            columnResourceName: 'colId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {}},
    MODEL_COMPARE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Model Compare Name',
            columnResourceName: 'colName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 50
        }
    },
    MODEL_COMPARE_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Model Compare ID',
            columnResourceName: 'colPId',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 50
        }
    },
    CUSTOMER_LEVEL: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Customer Level',
            columnResourceName: 'colCustomerLevel',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 50
        }
    },
    PRODUCT_LEVEL: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Product Level',
            columnResourceName: 'colProductLevel',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 50
        }
    },
    PERIOD_TYPE_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Period Level',
            columnResourceName: 'colPeriodMName',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 50
        }
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    COMPARE_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: 'Compare Type',
            columnResourceName: 'colType',
            alignment: HorizAlignment.Left
        },
        domainOptions: {
            maxLength: 50
        }
    },
};

const ModelCompareSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_MODELCOMPARE_ID',
                id_ui: 'MODEL_COMPARE_ID',
                name: 'MODEL_COMPARE_NAME'

    },

    searchProviderFields: vUI_Model_Compare_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Model_Compare_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const ModelCompareSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "ModelCompareSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'MODEL_COMPARE_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'MODEL_COMPARE_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'MODEL_COMPARE_ID', 'MODEL_COMPARE_NAME', 'CUSTOMER_LEVEL', 'PRODUCT_LEVEL', 'PERIOD_TYPE_NAME',
        "CREATED_DTTS", "MODIFIED_DTTS"
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelCompareSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ModelCompareSearch: ISearch = {
    searchName: "Find Model Compare",
    renderOptions: {ui5ResourceId: "ModelCompareSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ModelCompareSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ModelCompareBO", "ModelCompare", ModelCompareSearch, "Model Compare Search")
PAEnvironment.registerBusinessObjectSearch("ModelScorecardBO", "ModelScorecard", ModelCompareSearch, "Model Scorecard Search")
export {ModelCompareSearch}
